import React, { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import Fab from '@mui/material/Fab';
import UserViewEnums from '@/constants/users/UserViewEnums';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import MultiActionDialog from './MultiActionDialog';
import ShowForViews from './ShowForViews';

type MultiActionDialogManagerProps = {
  onEntityCreated?: () => void;
};
function MultiActionDialogManager({
  onEntityCreated = () => {},
}: MultiActionDialogManagerProps) {
  const [actionDialogOpen, setActionDialogOpen] = useState(false);

  return (
    <ShowForViews showFor={[UserViewEnums.ADMIN, UserViewEnums.EDITOR]}>
      <MultiActionDialog
        open={actionDialogOpen}
        handleClose={() => setActionDialogOpen(false)}
        onEntityCreated={onEntityCreated}
      />
      <Fab
        className="fixed bottom-4 right-4 z-20 sm:bottom-12 md:right-[72px]"
        color="secondary"
        data-testid="add-button"
        onClick={() => setActionDialogOpen(true)}
      >
        <AddIcon />
      </Fab>
    </ShowForViews>
  );
}

export default MultiActionDialogManager;
